import React, { useEffect, useState } from 'react';
import { getRequest } from 'modules/request';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { PublicCabinetLayout } from '../../components/ant/layouts/PublicCabinet';
import PublicListingCard from '../../components/views/private/Listings/PublicListingCard';
import PublicListingHead from '../../components/views/private/Listings/PublicListingHead';
import styles from 'components/ant/css/indexStyles.module.css';
import {useAuthContext} from "../../components/shared/Auth";

const Page = ({ username }) => {
    const { isAuth, signOut, data, userData } = useAuthContext();
  const [account, setAccount] = useState(false);
  const [listings, setListings] = useState(false);
  const [listingAmount, setListingAmount] = useState(false);
  const [followers, setFollowers] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
      fetch(`/api/user/${username}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json()).then((data) => {

          setAccount(data);
      });

  }, []);

  useEffect(() => {
    if (account?.id) {
        fetch(`/api/user/${account.id}/listings`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.json()).then((data) => {
            setListingAmount(data.count);
            setListings({...data, entries: data.data});
        })

      // getRequest()
      //   .get(`/listings`)
      //   .query({ page: page, perPage: 50, author: account.id })
      //   .then((res) => {
      //     setListingAmount(res.body?.count);
      //     setListings(res.body);
      //   });
      // getRequest()
      //   .get(`/users/${account.id}/followers`)
      //   .query({ page: 0, perPage: 12 })
      //   .then((res) => {
      //     setFollowers(res.body?.entries);
      //   });
    }
  }, [account, page]);

  return (
    <PublicCabinetLayout>
      <div className={styles.userDiv}>
        <PublicListingHead account={account} followers={followers} listingAmount={listingAmount} />
        <PublicListingCard listings={listings} changePage={setPage} />
      </div>
    </PublicCabinetLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  ctx.res.setHeader('Cache-Control', 'public, s-maxage=30, stale-while-revalidate=29');

  const accessToken = ctx.accessToken ?? '';
  const username = ctx.params?.username ?? '';
  return {
    props: {
      ...(await serverSideTranslations(ctx.locale, ['common'])),
      accessToken,
      username,
    },
  };
};

export default Page;
